import addTargetEventListener from 'mex_components/app/scripts/events/addTargetEventListener';

addTargetEventListener('click', '.js-toggle-previous-table-content-visible', function(event) {
  event.preventDefault();

  const button = this;
  const table = button.parentNode.querySelector('.js-table');

  if (table.getAttribute('data-visible') == 'limited') {
    table.setAttribute('data-visible', 'full');
    button.querySelector('span').innerHTML = 'Fewer';
  } else {
    table.setAttribute('data-visible', 'limited');
    button.querySelector('span').innerHTML = 'More';
  }
});
